<template>
  <div>
    <h6 style="margin: 0px !important">{{ ALCAKORT }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ ALCAKGUN }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
import moment from "moment";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      ALCAKORT: "",
      ALCAKGUN: 0,
    };
  },
  methods: {
    gelenData() {
      this.ALCAKORT = this.parseDate(this.params.data.ALCAKORT);

      this.ALCAKGUN = this.params.data.ALCAKGUN;
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
